module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div ui-view=\"content-section\">\r\n            <table-chart-page></table-chart-page>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-view/app-view.html
// module id = 80
// module chunks = 0